import * as Yup from "yup";
import { forceInt } from "Utils";

export const TagValidationSchema = Yup.object().shape({});

export const TagObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    name: null,
    slug: null,
    status: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let tag = Object.assign({}, TagObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        name: requestData.name,
        slug: requestData.slug,
        status: requestData.status,
    });

    return tag;
}
